import { Disclosure } from '@headlessui/react';
import React, { useState } from "react";
import { HiMenuAlt2 } from 'react-icons/hi';
import { IoMdClose } from 'react-icons/io';
import { NavLink } from 'react-router-dom';
import logo from '../assets/logo.png';

const navigation = [
    { name: 'Home', to: '/home', current: true },
    { name: 'About', to: '/about', current: false },
    { name: 'Services', to: '/services', current: false },
    { name: 'Contact', to: '/contact', current: false },
]


export default function Navbar() {
    const [header, setHeader] = useState(false);
    const [text, setText] = useState(false);


    const changeHeader = () => {
        if (window.scrollY >= 50) {
            setHeader(true)
            setText(true)
        } else {
            setHeader(false)
            setText(false)
        }
    }

    window.addEventListener('scroll', changeHeader)

    return (
        <Disclosure as="nav" className={header ? "bg-indigo-700 fixed top-0 left-0 w-full z-50 transition duration-300" : "bg-transparent fixed top-0 left-0 w-full z-50 transition duration-300"}>
            {({ open }) => (
                <>
                    <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
                        <div className="relative flex items-center justify-between h-16">
                            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                                {/* Mobile menu button*/}
                                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-indigo-800 bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <IoMdClose className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <HiMenuAlt2 className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                            <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                                <div className="flex items-center flex-grow-1">
                                    <img
                                        className="block h-8 w-auto"
                                        src={logo}
                                        alt="logo"
                                    />
                                    <h1 className={text ? "text-white ml-2 font-semibold text-xl font_poppins select-none" : "text-gray-700 ml-2 font-semibold text-xl font_poppins select-none"}>Language School</h1>
                                </div>
                                <div className="hidden sm:block sm:ml-auto">
                                    <div className="flex items-center space-x-4">
                                        {navigation.map((item) => (
                                            <NavLink
                                                exact
                                                key={item.name}
                                                to={item.to}
                                                className={text ? "font_poppins px-3 py-2 text-white" : "font_poppins px-3 py-2"}
                                                activeClassName={text ? "text-indigo-700 bg-white px-3 py-2 rounded-lg" : "text-white bg-indigo-700 hover:bg-indigo-800 px-3 py-2 rounded-lg"}
                                            >
                                                {item.name}
                                            </NavLink>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <Disclosure.Panel className="sm:hidden bg-white">
                        <div className="px-2 pt-2 pb-3 space-y-1">
                            {navigation.map((item) => (
                                <NavLink
                                    exact
                                    key={item.name}
                                    to={item.to}
                                    className= "font_poppins block py-2 px-3"
                                    activeClassName= "text-white bg-indigo-700 hover:bg-indigo-800 rounded-md block"
                                >
                                    {item.name}
                                </NavLink>
                            ))}
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    )
}
